/* eslint-disable jsx-a11y/aria-props */
import { Button } from "antd";
import React, { createRef, useCallback, useEffect, useState } from "react";
import { FaBars, FaCalendarPlus, FaQuestionCircle, FaSignOutAlt, FaTimes, FaUser } from "react-icons/fa";
import INavbarProps from "components/Navbar/INavbarProps";
import "./Navbar.css";
import useWindowDimensions from "utils/WindowSize";

import { modalListHeight } from "utils/Styles";

import FirebaseNotification from "../FirebaseNotification/FirebaseNotification";
import LogoHeader from "components/LogoHeader/LogoHeader";
// import CultureCombo from "components/CultureCombo/CultureCombo";
import { Enhanced } from "utils/ReactUtils";

const Navbar: React.FC<INavbarProps> = ({
	onReservedAreaClick,
	onLogoutClick,
	onNewReservationClick,
	onNotificationClick,
	onHelpClick,
	float,
	timer,
	t,
	sessionInfo,
}) => {
	const { width } = useWindowDimensions();
	const topNavbar: any = createRef();
	const sideNavbar: any = createRef();
	const [logoExpanded, setLogoExpanded] = useState<boolean>(width > 800);
	const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
	const [sidebarNavigationOpen, setSidebarNavigationOpen] = useState<boolean>(false);

	window.onscroll = () => {
		scrollFunction();
	};
	window.onresize = () => {
		resizeFunction();
	};

	const setAppContainerHeight = () => {
		let navbarHeight = document.getElementById("navbar")!.offsetHeight; //<-- QUESTO CAUSA UN ERRORE A CERTI RIAVVII
		document.getElementById("app-container")!.style.marginTop = `${navbarHeight}px`;
	};

	const setFooterHeight = () => {
		let footer: any = document.getElementsByClassName("custom-footer-iframe");
		let app: any = document.getElementById("app");
		if (footer && footer.length > 0 && footer[0].clientHeight > 0) {
			app.classList.remove("app-fullheight");
			footer[0].height = footer[0].contentWindow.document.body.lastElementChild.offsetHeight;
		} else {
			app.classList.add("app-fullheight");
		}
	};

	const setModalListHeight = () => {
		let elem: HTMLElement = document.getElementById("modal-scrollable-div")!;
		if (elem) {
			elem.style.height = modalListHeight();
		}
	};

	const scrollFunction = () => {
		if (logoExpanded) {
			let scroll = document.body.scrollTop > 100 || document.documentElement.scrollTop > 130;
			document.getElementById("logo-image")!.style.padding = scroll ? "0px" : "20px";
		}
		setAppContainerHeight();
	};

	const resizeFunction = useCallback(() => {
		setLogoExpanded(width > 800);
		setSidebarNavigationOpen(width < 800);
		setAppContainerHeight();
		setFooterHeight();
		setModalListHeight();
	}, [width]);

	const onOpen = () => {
		setSidebarOpen(true);
	};
	const onClose = () => {
		setSidebarOpen(false);
	};

	// useEffect(() => {
	// 	if (sidebarOpen && sideNavbar.current) sideNavbar.current.focus();
	// 	else topNavbar.current.focus();
	// }, [sideNavbar, sidebarOpen, topNavbar]);

	useEffect(() => {
		resizeFunction();
	}, [resizeFunction]);

	return (
		<>
			<div
				className={`navbar-wrapper`}
				id={"navbar"}
				style={{ position: float ? "fixed" : undefined }}
				ref={topNavbar}
				role="navigation"
				aria-label="toolbar"
			>
				<div className={`logo_wrapper`}>
					<LogoHeader logoExpanded={logoExpanded} />
				</div>
				<div className={`timer_wrapper`}>{timer}</div>

				<div className="navbar-spacer"></div>

				<div className={"topbar-navigation"}>
					<Button
						className="nav-button"
						onClick={() => {
							onNewReservationClick();
							onClose();
						}}
					>
						<FaCalendarPlus /> {t("Navbar.NuovaPrenotazione")}
					</Button>

					<Button
						className="nav-button"
						onClick={() => {
							onReservedAreaClick();
							onClose();
						}}
					>
						<FaUser /> {sessionInfo.nominativoUtente ?? t("Navbar.AreaPersonale")}
					</Button>

					{window.CONFIG.REACT_APP_NOTIFICHE && (
						<FirebaseNotification
							onClick={() => {
								onNotificationClick();
								onClose();
							}}
							text={t("Navbar.Notifiche")}
							className="nav-button"
						/>
					)}
				</div>

				<Button className={"open-sidebar-button"} onClick={onOpen} aria-label="menu button">
					<FaBars />
				</Button>

				{/* <div className={"mob_nav"}>
					{window.CONFIG.REACT_APP_NOTIFICHE && (
						<FirebaseNotification
							onClick={() => {
								onNotificationClick();
								onClose();
							}}
							text={t("Navbar.Notifiche")}
							className={"nav-button"}
						/>
					)}

					<FaBars onClick={onOpen} className={"sidebar-menu-element"} />
				</div> */}

				<div
					className={`sidebar-wrapper ${sidebarOpen ? "sidebar-wrapper-open" : ""}`}
					ref={sideNavbar}
					// eslint-disable-next-line jsx-a11y/no-noninteractive-tabindex
					tabIndex={0}
					aria-hidden={!sidebarOpen}
				>
					<div className="sidebar-wrapper-background"></div>
					<button onClick={onClose} className={"nav-button close-sidebar"} aria-label="close menu">
						<FaTimes></FaTimes>
					</button>

					<div className="sidebar-navigation" aria-hidden={!sidebarNavigationOpen}>
						<button
							className="nav-button"
							onClick={() => {
								onNewReservationClick();
								onClose();
							}}
						>
							<FaCalendarPlus />
							<span>{t("Navbar.NuovaPrenotazione")}</span>
						</button>
						<button
							className="nav-button"
							onClick={() => {
								onReservedAreaClick();
								onClose();
							}}
						>
							<FaUser />
							<span>{sessionInfo.nominativoUtente ?? t("Navbar.AreaPersonale")}</span>
						</button>
					</div>

					{/* These will always show: help, logout when available, etc */}
					<button
						className="nav-button"
						onClick={() => {
							onHelpClick();
							onClose();
						}}
					>
						<FaQuestionCircle />
						<span>{t("Navbar.Help")}</span>
					</button>

					{sessionInfo.isLogged && (
						<button
							className="nav-button"
							onClick={() => {
								onLogoutClick();
								onClose();
							}}
						>
							<FaSignOutAlt />
							<span>{t("Navbar.Logout")}</span>
						</button>
					)}
				</div>
			</div>
		</>
	);
};
export default Enhanced( Navbar,{componentNamespace:"Navbar"});
